module.exports = __webpack_public_path__ + "img/sitemap.31dfa8c6.png";